import React, { Fragment, useState, useEffect, useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../context/AppContext";

import * as Md from "react-icons/md";
import * as Io from "react-icons/io";
import Masonry from "react-layout-masonry";
import { Switch } from "antd";
import { toast } from "react-toastify";
import { HashLoader, PulseLoader } from "react-spinners";

import moment from "moment-timezone";

function EditPromotion() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { updatePromotion, promotion, getPromotions, promotionLoading } =
    useContext(AppContext);
  const [updateValues, setUpdateValues] = useState({
    title: "",
    description: "",
    price: 0,
    discount_price: 0,
    paymentType: "",
    startDate: "",
    endDate: "",
    offerCode: "",
    wPosition: "",
    mPosition: "",
    locations: [],
    doorDelivery: false,
    takeAway: false,
    file: null,
    wFile: null,
    web: false,
    mobile: false,
    promotionFor: "",
    redirectWebLink: "",
  });
  const [currentLocation, setCurrentLocation] = useState("");
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [webFile, setWebFile] = useState(null);
  const [webFilePreview, setWebFilePreview] = useState(null);
  const [fileDropped, setFileDropped] = useState(false);
  const [webFileDropped, setWebFileDropped] = useState(false);
  const [error, setError] = useState(false);
  const [pageIsLoading, setPageIsLoading] = useState(false);

  useEffect(() => {
    findPromotionById();
  }, [id, promotion]);

  useEffect(() => {
    if (updateValues.web === false) {
      setWebFile(null);
      setUpdateValues((prev) => ({ ...prev, wFile: null, wPosition: "" }));
      setWebFileDropped(false);
      setWebFilePreview(null);
    }
  }, [updateValues.web]);

  useEffect(() => {
    if (updateValues.mobile === false) {
      setFile(null);
      setUpdateValues((prev) => ({ ...prev, file: null, mPosition: "" }));
      setFileDropped(false);
      setFilePreview(null);
    }
  }, [updateValues.mobile]);

  const formatDateTime = (dateTimeString) => {
    const [date, time] = dateTimeString.split(" ");
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}T${time.substring(0, 5)}`;
  };

  const findPromotionById = () => {
    try {
      setPageIsLoading(true);

      if (!id || !promotion || (promotion && promotion?.length == 0)) {
        console.log("No ID or promotions available");
        return;
      }
      const data = promotion?.find((x) => x?.offerId == id);

      const arrLocation =
        data?.locations && data?.locations.length != 0
          ? data?.locations.split(",")
          : [];

      const startDateString = data?.startDate
        ? formatDateTime(data.startDate)
        : "";
      const endDateString = data?.endDate ? formatDateTime(data.endDate) : "";
      setUpdateValues({
        title: data?.title,
        description: data?.description,
        discount_price: data?.discount_price,
        doorDelivery: data?.doorDelivery,
        endDate: endDateString,
        file: data?.file,
        locations: arrLocation,
        mPosition: data?.mPosition,
        wPosition: data?.wPosition,
        wFile: data?.wFile,
        offerCode: data?.offerCode,
        paymentType: data?.paymentType,
        price: data?.price ?? 0,
        startDate: startDateString,
        takeAway: data?.takeAway,
        web: data?.web,
        mobile: data?.mobile,
        promotionFor: data?.promotionFor,
        redirectWebLink: data?.redirectWebLink,
      });

      if (data.file != null) {
        setFilePreview(data.file);
        setFile(data.file);
        setFileDropped(true);
      }

      if (data.wFile != 0) {
        setWebFilePreview(data.wFile);
        setWebFile(data.wFile);
        setWebFileDropped(true);
      }
    } finally {
      setPageIsLoading(false);
    }
  };

  const handleAddLocation = () => {
    if (currentLocation.trim() !== "") {
      setUpdateValues((prevOffer) => ({
        ...prevOffer,
        locations: [...prevOffer.locations, currentLocation.trim()],
      }));
      setCurrentLocation("");
    }
  };

  const handleRemoveLocation = (index) => {
    const updatedLocations = updateValues.locations.filter(
      (_, i) => i !== index
    );
    setUpdateValues((prevOffer) => ({
      ...prevOffer,
      locations: updatedLocations,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleDoorDelivery = () => {
    setUpdateValues((prev) => {
      return {
        ...prev,
        doorDelivery: !prev.doorDelivery,
      };
    });
  };

  const handleTakeaway = () => {
    setUpdateValues((prev) => {
      return {
        ...prev,
        takeAway: !prev.takeAway,
      };
    });
  };

  const handleClick = () => {
    document.querySelector(".drop-zone__input_mobile").click();
  };

  const handleWebFileClick = () => {
    document.querySelector(".drop-zone__input").click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setUpdateValues((prev) => ({ ...prev, file: selectedFile }));
      const previewUrl = URL.createObjectURL(selectedFile);
      setFilePreview(previewUrl);
      setFileDropped(true);
    }
  };

  const handleWebFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setWebFile(selectedFile);
      setUpdateValues((prev) => ({ ...prev, wFile: selectedFile }));
      const previewUrl = URL.createObjectURL(selectedFile);
      setWebFilePreview(previewUrl);
      setWebFileDropped(true);
    }
  };

  const handleValidation = () => {
    if (
      updateValues?.title == 0 ||
      updateValues?.startDate == 0 ||
      updateValues?.endDate == 0 ||
      updateValues?.promotionFor.length == 0
    ) {
      setError(true);
      return true;
    }
    return false;
  };

  const isBookingValid = () => {
    const now = moment().tz("Europe/London");
    console.log(now, "now");

    const bookingStartDate = moment(updateValues?.startDate).tz(
      "Europe/London"
    );
    const bookingEndDate = moment(updateValues?.endDate).tz("Europe/London");

    if (!bookingStartDate.isValid() || !bookingEndDate.isValid()) {
      console.error(
        "Invalid date format:",
        updateValues?.startDate,
        updateValues?.endDate
      );

      return false;
    }

    if (bookingStartDate.isBefore(now) || bookingEndDate.isBefore(now)) {
      return false;
    }
    if (bookingEndDate.isBefore(bookingStartDate)) {
      return false;
    }

    return true;
  };

  const handleWebDisable = (event) => {
    setUpdateValues((prev) => ({
      ...prev,
      web: !prev.web,
    }));
  };

  const handleUpdatePromotions = async (e) => {
    e.preventDefault();

    const isValid = handleValidation();
    if (isValid == true) return;
    const isValidBookingTime = isBookingValid();

    if (isValidBookingTime === false) {
      toast.error("Please select a valid start and end time!");
      return;
    }

    if (updateValues.web === true && updateValues.wPosition.length == 0) {
      toast.error("Please choose the position of the image for the website!");
      return;
    }

    if (
      updateValues.web === true &&
      (!updateValues.wFile || updateValues.wFile.length == 0)
    ) {
      toast.error("Please upload image for the website!");
      return;
    }

    if (updateValues.mobile === true && updateValues.mPosition.length == 0) {
      toast.error("Please choose the position of the image for Mobile app!");
      return;
    }

    if (
      updateValues.mobile === true &&
      (!updateValues.file || updateValues.file.length == 0)
    ) {
      toast.error("Please upload image for the Mobile!");
      return;
    }

    if (!updateValues.web && !updateValues.mobile) {
      toast.error("Please choose Web or Mobile before create a promotion!");
      return;
    }

    const price =
      updateValues.price && typeof updateValues.price == "string"
        ? parseInt(updateValues.price)
        : updateValues.price;
    const Discountprice =
      updateValues.discount_price &&
      typeof updateValues.discount_price == "string"
        ? parseInt(updateValues.discount_price)
        : updateValues.discount_price;

    const formData = new FormData();
    formData.append("offerId", id);
    formData.append("title", updateValues?.title);
    formData.append("description", updateValues?.description);
    formData.append("paymentType", updateValues.paymentType);
    formData.append("price", price ?? 0);
    formData.append("discount_price", Discountprice ?? 0);
    formData.append("startDate", updateValues?.startDate);
    formData.append("endDate", updateValues?.endDate);
    formData.append("locations", updateValues?.locations);
    formData.append("doorDelivery", updateValues.doorDelivery);
    formData.append("takeAway", updateValues.takeAway);
    formData.append("offerCode", updateValues?.offerCode.toUpperCase());
    formData.append("web", updateValues.web);
    formData.append("mobile", updateValues.mobile);
    formData.append("wPosition", updateValues.wPosition);
    formData.append("mPosition", updateValues.mPosition);

    formData.append("promotionFor", updateValues?.promotionFor);
    formData.append("redirectWebLink", updateValues?.redirectWebLink);

    if (updateValues.mobile === true && typeof updateValues.file === "object") {
      formData.append("file", updateValues.file);
    }
    if (updateValues.web === true && typeof updateValues.wFile === "object") {
      formData.append("wFile", updateValues.wFile);
    }

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    // return;

    const token = localStorage.getItem("UserRetention");

    if (!token) {
      toast.error("Authentication Failed, Please login again!");
      return;
    }

    await updatePromotion(formData, {
      onSuccess: async (res) => {
        toast.success("Promotion has been updated successfully!");
        navigate("/promotion-list");
        await getPromotions(token);
      },
      onFailed: (err) => {
        toast.error("Promotion not updated!");
        console.log("Promotion update err", err);
      },
    });
  };

  const today = new Date().toISOString().slice(0, 16);

  return (
    <Fragment>
      <MasterLayout>
        <div className="container w-80 mx-auto  ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <h6 className="my-4">Edit Promotion</h6>
            </div>
          </div>
          <div className="card  p-5">
            {!pageIsLoading && !promotionLoading ? (
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <form onSubmit={handleUpdatePromotions}>
                    {/* <div className="d-flex justify-content-between align-items-center mb-4">
                      <label htmlFor="" className="form-label">
                        Active
                        <Switch className="active-switch mx-3" />
                        Deactive
                      </label>
                    </div> */}
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Offer Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={updateValues?.title}
                          onChange={handleChange}
                        />
                        {error && updateValues.title.length == 0 && (
                          <span className="error__">Title is required!</span>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Offer Code</label>
                        <input
                          type="text"
                          className="form-control text-uppercase"
                          name="offerCode"
                          value={updateValues?.offerCode}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Offer Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        value={updateValues?.description}
                        onChange={handleChange}
                        rows={7}
                      />
                    </div>

                    <div className="mb-3">
                      <p className="mb-0 form-label">Payment Type</p>
                      <div className="d-flex">
                        <div className="mx-2 mt-2">
                          <label className="form-label cursor-pointer">
                            <input
                              name="paymentType"
                              type="radio"
                              className="form-check-input mb-0 mx-2"
                              value="fixedPrice"
                              checked={
                                updateValues.paymentType === "fixedPrice"
                              }
                              onChange={handleChange}
                            />
                            Fixed Price
                          </label>
                        </div>
                        <div className="mx-3 mt-2">
                          <label className="form-label cursor-pointer">
                            <input
                              name="paymentType"
                              type="radio"
                              className="form-check-input mb-0 mx-2"
                              value="DiscountAmt"
                              checked={
                                updateValues.paymentType === "DiscountAmt"
                              }
                              onChange={handleChange}
                            />
                            Discount Percentage
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-lg-3 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">Original Price</label>
                          <input
                            type="text"
                            className="form-control"
                            name="price"
                            value={updateValues?.price}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3 col-sm-12">
                        <div className="mb-3">
                          <label className="form-label">Discounted Price</label>
                          <input
                            type="text"
                            className="form-control"
                            name="discount_price"
                            value={updateValues.discount_price}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3 col-sm-12 mb-3">
                        <label className="form-label">Start Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="startDate"
                          value={updateValues?.startDate}
                          onChange={handleChange}
                          min={today}
                        />
                        {error && updateValues.startDate.length == 0 && (
                          <span className="error__">
                            Start Date is required!
                          </span>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-3 col-sm-12 mb-3">
                        <label className="form-label">End Date</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          name="endDate"
                          value={updateValues?.endDate}
                          onChange={handleChange}
                          min={today}
                        />
                        {error && updateValues.endDate.length == 0 && (
                          <span className="error__">End Date is required!</span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4">
                      <div className="row"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="location__">
                          <label className="form-label ">Location</label>

                          <div className="mb-3">
                            <div className="location-in">
                              <input
                                type="text"
                                className="form-control"
                                value={currentLocation}
                                onChange={(e) =>
                                  setCurrentLocation(e.target.value)
                                }
                              />
                              <button
                                onClick={handleAddLocation}
                                type="button"
                                className="add-btn px-3 mx-4 my-2"
                              >
                                <i>
                                  <Io.IoMdAdd />
                                </i>
                              </button>
                            </div>
                            <div>
                              <ul>
                                {updateValues &&
                                updateValues.locations &&
                                Array.isArray(updateValues.locations) &&
                                updateValues.locations.length != 0
                                  ? updateValues.locations.map((loc, index) => (
                                      <div className="location_id" key={index}>
                                        <li>{loc}</li>
                                        <button
                                          type="button"
                                          className="remove-btn"
                                          onClick={() =>
                                            handleRemoveLocation(index)
                                          }
                                        >
                                          <Md.MdDelete />
                                        </button>
                                      </div>
                                    ))
                                  : ""}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="row">
                          <div className="col-md-6 col-lg-6 col-sm-12 mb-3">
                            <p className="mb-0 form-label mt-3">
                              Door Delivery
                            </p>
                            <div className="d-flex">
                              <div className="mx-2">
                                <label className="form-label cursor-pointer">
                                  <input
                                    name="doorDelivery"
                                    type="radio"
                                    className="form-check-input mb-0 mx-2"
                                    value={true}
                                    checked={
                                      updateValues?.doorDelivery === true
                                    }
                                    onChange={handleDoorDelivery}
                                  />
                                  Yes
                                </label>
                              </div>
                              <div className="mx-3">
                                <label className="form-label cursor-pointer">
                                  <input
                                    name="doorDelivery"
                                    type="radio"
                                    className="form-check-input mb-0 mx-2"
                                    value={false}
                                    checked={
                                      updateValues?.doorDelivery === false
                                    }
                                    onChange={handleDoorDelivery}
                                  />
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-6 col-sm-12 mb-3">
                            <p className="mb-0 form-label mt-3">Takeaway</p>
                            <div className="d-flex">
                              <div className="mx-2">
                                <label className="form-label cursor-pointer">
                                  <input
                                    type="radio"
                                    className="form-check-input mb-0 mx-2"
                                    value={true}
                                    checked={updateValues.takeAway === true}
                                    onChange={handleTakeaway}
                                  />
                                  Yes
                                </label>
                              </div>
                              <div className="mx-3">
                                <label className="form-label cursor-pointer">
                                  <input
                                    type="radio"
                                    className="form-check-input mb-0 mx-2"
                                    value={false}
                                    checked={updateValues.takeAway === false}
                                    onChange={handleTakeaway}
                                  />
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="" className="form-label">
                            Promotion For <span className="text-danger">*</span>
                          </label>
                          <select
                            name="promotionFor"
                            id=""
                            className="form-select"
                            onChange={handleChange}
                          >
                            <option
                              value="order-online"
                              selected={
                                updateValues?.promotionFor === "order-online"
                              }
                            >
                              Order Online
                            </option>
                            <option
                              value="table-reservation"
                              selected={
                                updateValues?.promotionFor ===
                                "table-reservation"
                              }
                            >
                              Table Reservation
                            </option>
                            <option
                              value="other"
                              selected={updateValues?.promotionFor === "other"}
                            >
                              other
                            </option>
                          </select>
                          {error && updateValues.promotionFor.length == 0 && (
                            <p className="err__msg">
                              The reason for the promotion is required!
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        {updateValues?.promotionFor == "other" && (
                          <div className="form-group">
                            <label htmlFor="" className="form-label">
                              Web Redirection Link
                            </label>
                            <input
                              type="text"
                              name="redirectWebLink"
                              id=""
                              className="form-control"
                              value={updateValues?.redirectWebLink}
                              onChange={handleChange}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <br />
                    <div className="">
                      <label htmlFor="device" className="form-label">
                        Web
                        <Switch
                          defaultValue={updateValues.web}
                          onChange={handleWebDisable}
                          checked={updateValues.web}
                          id="device"
                          className="mx-3"
                        />{" "}
                      </label>

                      <p className="mb-0 form-label mt-4">
                        Position type for Web
                      </p>
                      <select
                        className="form-select form-select-sm w-50 bg-base border text-secondary-light"
                        value={updateValues.wPosition}
                        onChange={(e) => {
                          setUpdateValues((prev) => ({
                            ...prev,
                            wPosition: e.target.value,
                          }));
                        }}
                        disabled={!updateValues.web}
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        <option value="banner">Banner</option>
                        <option value="slider">Slider</option>
                        {/* <option value="poster">Poster</option> */}
                      </select>
                      <br />
                      <div className="mb-5 position-relative">
                        <h6>Add an image for your offer</h6>
                        <span>
                          Your Image will be appears on your Web. For best
                          results, use a 4:3 aspect ratio.
                        </span>
                        {!webFilePreview && (
                          <div
                            className={
                              updateValues.web === false
                                ? "drop-zone disabled"
                                : "drop-zone"
                            }
                            onClick={handleWebFileClick}
                          >
                            <span className="drop-zone__prompt_web ">
                              Click to upload
                            </span>
                            <input
                              type="file"
                              name="file"
                              className="drop-zone__input"
                              onChange={handleWebFileChange}
                              style={{ display: "none" }}
                              disabled={!updateValues.web}
                            />
                          </div>
                        )}

                        {webFile && webFilePreview && (
                          <>
                            <button
                              type="button"
                              className="clear_img"
                              onClick={() => {
                                setWebFile(null);
                                setWebFilePreview(null);
                                setWebFileDropped(false);
                                setUpdateValues((prev) => ({
                                  ...prev,
                                  wFile: null,
                                }));
                              }}
                            >
                              Clear Image
                            </button>
                            <p>Selected file:</p>
                            <img
                              src={webFilePreview}
                              alt="preview_image"
                              srcset=""
                              className="preview_image mobile"
                            />
                          </>
                        )}
                      </div>
                    </div>

                    <div className="">
                      <label htmlFor="device" className="form-label">
                        Mobile
                        <Switch
                          defaultValue={updateValues.mobile}
                          onChange={() => {
                            setUpdateValues((prev) => ({
                              ...prev,
                              mobile: !prev.mobile,
                            }));
                          }}
                          id="device"
                          className="mx-3"
                          checked={updateValues.mobile}
                        />{" "}
                      </label>

                      <p className="mb-0 form-label mt-4">
                        Position type for Mobile
                      </p>
                      <select
                        className="form-select form-select-sm w-50 bg-base border text-secondary-light"
                        value={updateValues.mPosition}
                        onChange={(e) =>
                          setUpdateValues((prev) => ({
                            ...prev,
                            mPosition: e.target.value,
                          }))
                        }
                        disabled={!updateValues.mobile}
                      >
                        <option value="" selected disabled>
                          Select
                        </option>
                        <option value="banner">Banner</option>
                        <option value="slider">Slider</option>
                        <option value="poster">Poster</option>
                      </select>
                      <br />
                      <div className="mb-5 position-relative">
                        <h6>Add an image for your offer</h6>
                        <span>
                          Your Image will be appears on your Mobile. For best
                          results, use a 4:3 aspect ratio.
                        </span>
                        {!filePreview && (
                          <div
                            className={
                              updateValues.mobile
                                ? "drop-zone"
                                : "drop-zone disabled"
                            }
                            onClick={handleClick}
                          >
                            <span className="drop-zone__prompt">
                              Click to upload
                            </span>
                            <input
                              type="file"
                              name="file"
                              className="drop-zone__input_mobile"
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                              disabled={!updateValues.mobile}
                            />
                          </div>
                        )}

                        {file && filePreview && (
                          <>
                            <button
                              type="button"
                              className="clear_img"
                              onClick={() => {
                                setFile(null);
                                setFilePreview(null);
                                setFileDropped(false);
                                setUpdateValues((prev) => ({
                                  ...prev,
                                  file: null,
                                }));
                              }}
                            >
                              Clear Image
                            </button>
                            <p>Selected file:</p>
                            <img
                              src={filePreview}
                              alt="preview_image"
                              srcset=""
                              className="preview_image web"
                            />
                          </>
                        )}
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn add_btn mt-3"
                      id="add_prom"
                      disabled={promotionLoading}
                    >
                      {promotionLoading ? (
                        <PulseLoader color="#fff" size={10} />
                      ) : (
                        "Save Offer"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            ) : (
              <div
                className="mx-auto text-center"
                style={{ padding: "20px 0" }}
              >
                <HashLoader color="#f44336" />
                <span className="pt-3 user-select-none">Please Wait..</span>
              </div>
            )}
          </div>
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default EditPromotion;
